export default __webpack_public_path__ + "static/media/mini-close.f0a8a642.svg";